import React, { Component } from 'react'
import Paper from '@material-ui/core/Paper'
import SubscriptionPacksTable from './containers/subscription-packs-table'
import EditSubscriptionPackDialog from './containers/edit-subscription-pack-dialog'
import ViewSubscriptionPackLogsDialog from './containers/view-events'
import NavigationAppShell from '../../common/navigation-app-shell'
import Y from '../../y18n'


class SubscriptionPacksPage extends Component {
  render () {
    return (
      <NavigationAppShell
        content={
          <Paper>
            <SubscriptionPacksTable />
            <EditSubscriptionPackDialog />
            <ViewSubscriptionPackLogsDialog />
          </Paper>
        }
        pageName={Y`subscription_packs`}
      />
    )
  }
}

export default SubscriptionPacksPage


// WEBPACK FOOTER //
// ./src/pages/subscription-packs/index.js